export function initMainTable() {
    if ($('.tabs-switchers.main-page').length) {
        const $tableSwitcher = $('.tabs-switchers.main-page');

        $tableSwitcher.on('click', function (e) {
            if (window.innerWidth < 768) {
                $(this).toggleClass('rolled');
            }
        });

        if (window.innerWidth < 768) {
            $tableSwitcher.on('click', '.switch:not(.active)', function (e) {
                const tabValue = $(this).data('tab');
                $(this).addClass('active');

                $('[data-tabs-block]').find(`[data-tab="${tabValue}"]`).addClass('active').siblings('.tab').removeClass('active');
                $(this).addClass('active').siblings('.switch').removeClass('active');
                $(this).css('order', '1');
                $(this).siblings('.switch').css('order', '2');
            });
        }
    }
}